<form nz-form [formGroup]="validateForm" autocomplete="off">
    <nz-tabset nzType="card" class="tabs-gvnv">
        <nz-tab [nzTitle]="'A. THÔNG TIN CHUNG'">
            <nz-card class="card">
                <div nz-row nzGutter="24" #form>
                    <div nz-col nzSm="24" nzMd="24" nzLg="4" nzXl="3" style="text-align: center;">
                        <nz-form-item>
                            <div class="form-group">
                                <fieldset class="form-group">
                                    <label>Hình đại diện</label>
                                    <button ngClass="btnDelImg" nz-button nzType="primary" nzDanger
                                        (click)="removeImage()" *ngIf="isImageSaved">Xóa</button>
                                    {{imageError}}
                                    <div class="custom-file fileInputProfileWrap">
                                        <input type="file" (change)="fileChangeEvent($event)" class="fileInputProfile">
                                        <div class="img-space">
                                            <ng-container *ngIf="isImageSaved; else elseTemplate">
                                                <img [src]="cardImageBase64" />
                                            </ng-container>
                                            <ng-template #elseTemplate>
                                                <img src="./../../assets/img/noimg.jpg" class="img-responsive">
                                            </ng-template>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </nz-form-item>
                    </div>
                    <div nz-col nzSm="24" nzMd="24" nzLg="20" nzXl="21">
                        <div nz-row nzGutter="24">
                            <div nz-col nzSm="24" nzMd="8">
                                <nz-form-item>
                                    <nz-form-label #label nzSpan="24" nzFor="staffCode">Mã định danh</nz-form-label>
                                    <nz-form-control nzSpan="24">
                                        <input nz-input formControlName="staffCode" placeholder="Mã định danh"
                                            name="staffCode" id="staffCode" readonly>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <!-- <div nz-col nzSm="24" nzMd="8">
                <nz-form-item>
                  <nz-form-label #label nzSpan="24" nzFor="provinceCode">Mã định danh cấp Tỉnh</nz-form-label>
                  <nz-form-control nzSpan="24">
                    <input nz-input formControlName="provinceCode" placeholder="Nhập mã định danh cấp tỉnh"
                      name="provinceCode" id="provinceCode" [jAutofocus]>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSm="24" nzMd="8">
                <nz-form-item>
                  <nz-form-label #label nzSpan="24" nzFor="ministryCode">Mã định danh cấp Bộ</nz-form-label>
                  <nz-form-control nzSpan="24">
                    <input nz-input formControlName="ministryCode" placeholder="Nhập mã định danh cấp Bộ"
                      name="ministryCode" id="ministryCode">
                  </nz-form-control>
                </nz-form-item>
              </div> -->
                            <div nz-col nzSm="24" nzMd="8">
                                <nz-form-item>
                                    <nz-form-label #label nzSpan="24" nzFor="fullName" nzRequired>Họ tên</nz-form-label>
                                    <nz-form-control nzSpan="24" nzErrorTip="Nhập trường thông tin bắt buộc">
                                        <input nz-input formControlName="fullName" placeholder="Nhập họ tên"
                                            name="fullName" id="fullName">
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzSm="24" nzMd="8">
                                <nz-form-item>
                                    <nz-form-label #label nzSpan="24" nzFor="gender" nzRequired>Giới
                                        tính</nz-form-label>
                                    <nz-form-control nzSpan="24">
                                        <nz-radio-group formControlName="gender">
                                            <label nz-radio [nzValue]="1">Nam</label>
                                            <label nz-radio [nzValue]="0">Nữ</label>
                                        </nz-radio-group>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzSm="24" nzMd="8">
                                <nz-form-item>
                                    <nz-form-label #label nzSpan="24" nzFor="yearOfBirth" nzRequired>Năm
                                        sinh</nz-form-label>
                                    <nz-form-control nzSpan="24" nzErrorTip="Nhập trường thông tin bắt buộc">
                                        <nz-date-picker [nzPlaceHolder]="'chọn năm'" formControlName="yearOfBirth"
                                            nzMode="year">
                                        </nz-date-picker>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzSm="24" nzMd="8">
                                <ng-container *ngIf="formType === 2">
                                    <nz-form-item>
                                        <nz-form-label #label nzSpan="24" nzFor="positionGVId" nzRequired>Vị trí công
                                            tác</nz-form-label>
                                        <nz-form-control nzSpan="24" nzErrorTip="Nhập vị trí công tác">
                                            <asc-autocomplete required label="Vị trí công tác"
                                                [ascModel]="PositionControl" required
                                                (ascModelChange)="changePosition($event)"
                                                placeholder="Chọn vị trí công tác..." formControlName="positionGVId"
                                                [getListAC]="getPositionACFn">
                                            </asc-autocomplete>
                                        </nz-form-control>
                                    </nz-form-item>
                                </ng-container>
                                <ng-container *ngIf="formType === 3 || formType === 4">
                                    <nz-form-item>
                                        <nz-form-label #label nzSpan="24" nzFor="position" nzRequired>Vị trí công
                                            tác</nz-form-label>
                                        <nz-form-control nzSpan="24" nzErrorTip="Nhập trường thông tin bắt buộc">
                                            <input nz-input formControlName="position"
                                                placeholder="Nhập vị trí công tác" name="position" id="position">
                                        </nz-form-control>
                                    </nz-form-item>
                                </ng-container>
                            </div>
                            <div nz-col nzSm="24" nzMd="8">
                                <nz-form-item>
                                    <ng-container *ngIf="formType === 2">
                                        <nz-form-label #label nzSpan="24" nzFor="yearsOfService">Số năm dạy
                                            học</nz-form-label>
                                    </ng-container>
                                    <ng-container *ngIf="formType === 3 || formType === 4">
                                        <nz-form-label #label nzSpan="24" nzFor="yearsOfService">Số năm làm
                                            việc</nz-form-label>
                                    </ng-container>
                                    <nz-form-control nzSpan="24">
                                        <nz-input-number formControlName="yearsOfService" [nzMax]='70'
                                            [nzMin]='0'></nz-input-number>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzSm="24" nzMd="8">
                                <nz-form-item>
                                    <ng-container *ngIf="formType === 2">
                                        <nz-form-label #label nzSpan="24" nzFor="yearsOfTeaching">Số năm dạy học sinh
                                            khuyết tật</nz-form-label>
                                    </ng-container>
                                    <ng-container *ngIf="formType === 3 || formType === 4">
                                        <nz-form-label #label nzSpan="24" nzFor="yearsOfTeaching">Số năm làm việc với
                                            người khuyết tật</nz-form-label>
                                    </ng-container>
                                    <nz-form-control nzSpan="24">
                                        <nz-input-number formControlName="yearsOfTeaching" [nzMax]='70'
                                            [nzMin]='0'></nz-input-number>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzSm="24" nzMd="8">
                                <nz-form-item>
                                    <nz-form-label #label nzSpan="24" nzFor="folkId" nzRequired>Dân tộc</nz-form-label>
                                    <nz-form-control nzSpan="24" nzErrorTip="Nhập trường thông tin bắt buộc">
                                        <asc-autocomplete label="Dân tộc" [ascModel]="FolkControl"
                                            (ascModelChange)="changeFolk($event)" formControlName="folkId"
                                            placeholder="Chọn dân tộc..." [getListAC]="getFolkACFn">
                                        </asc-autocomplete>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <ng-container *ngIf="isNoteFolk">
                                <div nz-col nzSm="24" nzMd="8">
                                    <nz-form-item>
                                        <nz-form-label #label nzSpan="24" nzFor="folk">Nhập dân tộc</nz-form-label>
                                        <nz-form-control nzSpan="24">
                                            <input nz-input formControlName="folk" placeholder="Nhập dân tộc">
                                        </nz-form-control>
                                    </nz-form-item>
                                </div>
                            </ng-container>
                            <div nz-col nzSm="24" nzMd="8">
                                <nz-form-item>
                                    <nz-form-label #label nzSpan="24" nzFor="nationalityId" nzRequired>Quốc
                                        tịch</nz-form-label>
                                    <nz-form-control nzSpan="24" nzErrorTip="Nhập trường thông tin bắt buộc">
                                        <asc-autocomplete label="Quốc tịch" [ascModel]="natioNalityControl"
                                            (ascModelChange)="changenatioNality($event)" placeholder="Chọn quốc tịch..."
                                            formControlName="nationalityId" [getListAC]="getnatioNalityACFn">
                                        </asc-autocomplete>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzSm="24" nzMd="8">
                                <nz-form-item>
                                    <nz-form-label #label nzSpan="24" nzFor="personnelStatusId" nzRequired>Tình trạng
                                        làm việc
                                    </nz-form-label>
                                    <nz-form-control nzSpan="24" [nzErrorTip]="errorTpl2">
                                        <asc-autocomplete required label="tình trạng làm việc"
                                            [ascModel]="EmploymentStatusIdControl" formControlName="employmentStatusId"
                                            (ascModelChange)="changePersonnelstatus($event)"
                                            placeholder="Chọn tình trạng làm việc..."
                                            [getListAC]="getPersonnelstatusACFn">
                                        </asc-autocomplete>
                                        <ng-template #errorTpl2 let-control>
                                            <ng-container *ngIf="control.hasError('required')"> Nhập trường thông tin
                                                bắt buộc </ng-container>
                                        </ng-template>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzSm="24" nzMd="8">
                                <nz-form-item>
                                    <nz-form-label #label nzSpan="24" nzFor="contractTypeId">Loại hợp
                                        đồng</nz-form-label>
                                    <nz-form-control nzSpan="24">
                                        <asc-autocomplete label="Loại hợp đồng" [ascModel]="ContractTypeControl"
                                            (ascModelChange)="changeContractType($event)"
                                            placeholder="Chọn loại hợp đồng..." formControlName="contractTypeId"
                                            [getListAC]="getContractTypeACFn">
                                        </asc-autocomplete>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzSm="24" nzMd="8">
                                <nz-form-item>
                                    <nz-form-label #label nzSpan="24" nzFor="qualificationId" nzRequired>Trình độ đào
                                        tạo</nz-form-label>
                                    <nz-form-control nzSpan="24" nzErrorTip="Nhập trường thông tin bắt buộc">
                                        <!-- <asc-autocomplete required label="Trình độ đào tạo" [ascModel]="QualificationControl"
                      (ascModelChange)="changeQualification($event)" placeholder="Chọn trình độ đào tạo..."
                      formControlName="qualificationId" [getListAC]="getQualificationACFn">
                    </asc-autocomplete> -->
                                        <nz-select formControlName="qualificationId" nzAllowClear
                                            nzPlaceHolder="Chọn trình độ" nzShowSearch>
                                            <nz-option-group nzLabel="Ngành sư phạm">
                                                <nz-option *ngFor="let item of listQualification" [nzValue]="item.id"
                                                    [nzLabel]="item.name"></nz-option>
                                            </nz-option-group>
                                            <nz-option-group nzLabel="Ngành Khác">
                                                <nz-option *ngFor="let item of listQualificationKhac"
                                                    [nzValue]="item.id" [nzLabel]="item.name"></nz-option>
                                            </nz-option-group>
                                        </nz-select>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <div nz-col nzSm="24" nzMd="8">
                                <nz-form-item>
                                    <nz-form-label #label nzSpan="24">Chuyên ngành đào tạo</nz-form-label>
                                    <nz-form-control nzSpan="24">
                                        <asc-autocomplete label="Chuyên ngành đào tạo" [ascModel]="MajorControl"
                                            (ascModelChange)="changeMajor($event)"
                                            placeholder="Chọn chuyên ngành đào tạo..." [getListAC]="getMajorACFn">
                                        </asc-autocomplete>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>

                            <div nz-col nzSm="24" nzMd="12">
                                <nz-form-item>
                                    <nz-form-label #label nzSpan="24" nzFor="staffUnfostered" nzRequired>Có bồi dưỡng về
                                        giáo dục người khuyết tật</nz-form-label>
                                    <nz-form-control nzSpan="24">
                                        <nz-radio-group formControlName="staffUnfostered">
                                            <label nz-radio [nzValue]="true">Có</label>
                                            <label nz-radio [nzValue]="false">Chưa</label>
                                        </nz-radio-group>
                                    </nz-form-control>
                                </nz-form-item>
                            </div>
                            <ng-container *ngIf="staffUnfosteredChecked === true">
                                <div nz-col nzSm="24" nzMd="12">
                                    <nz-form-item>
                                        <nz-form-label #label nzSpan="24" nzRequired>Bồi dưỡng về giáo dục người khuyết
                                            tật (chọn nhiều)</nz-form-label>
                                        <nz-select nzMode="tags" nzPlaceHolder="Chọn cấp học"
                                            [(ngModel)]="listDiplomaSelect" [ngModelOptions]="{standalone: true}">
                                            <nz-option *ngFor="let option of listDiploma" [nzLabel]="option.name"
                                                [nzValue]="option.value">
                                            </nz-option>
                                        </nz-select>
                                    </nz-form-item>
                                </div>
                            </ng-container>

                        </div>
                    </div>
                </div>
                <div nz-row nzGutter="24">
                    <div nz-col nzSpan="24">
                        <nz-tabset nzType="card">
                            <nz-tab [nzTitle]="'THÔNG TIN LIÊN HỆ'">
                                <div nz-row nzGutter="24">
                                    <div nz-col nzSm="24" nzMd="8">
                                        <nz-form-item>
                                            <nz-form-label nzSpan="24" nzRequired #label>CMND/CCCD/ĐDCD</nz-form-label>
                                            <nz-form-control nzSpan="24" nzErrorTip="Nhập trường thông tin bắt buộc">
                                                <input nz-input placeholder="Nhấp số..." formControlName="idNumber"
                                                    required>
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>
                                    <div nz-col nzSm="24" nzMd="8">
                                        <nz-form-item>
                                            <nz-form-label #label nzSpan="24" nzFor="phoneNumber">Số điện
                                                thoại</nz-form-label>
                                            <nz-form-control nzSpan="24" nzErrorTip="Nhập số điện thoại">
                                                <input maxlength="10" nz-input formControlName="phoneNumber"
                                                    name="phoneNumber" id="phoneNumber" type="text"
                                                    placeholder="số điện thoại">
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>
                                    <div nz-col nzSm="24" nzMd="8">
                                        <nz-form-item>
                                            <nz-form-label #label nzSpan="24" nzFor="email">Email</nz-form-label>
                                            <nz-form-control nzSpan="24" nzErrorTip="Nhập email">
                                                <input nz-input formControlName="email" name="email" id="email"
                                                    type="email" placeholder="Nhập email">
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>

                                    <div nz-col nzSm="24" nzMd="8">
                                        <nz-form-item>
                                            <nz-form-label #label nzSpan="24" nzFor="provinceId">Tỉnh
                                                thành</nz-form-label>
                                            <nz-form-control nzSpan="24" nzErrorTip="Nhập tỉnh thành">
                                                <asc-autocomplete label="Tỉnh thành" [ascModel]="ProvinceControl"
                                                    (ascModelChange)="changeProvince($event)"
                                                    placeholder="Chọn tỉnh thành..." [getListAC]="getProvinceACFn">
                                                </asc-autocomplete>
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>
                                    <div nz-col nzSm="24" nzMd="8">
                                        <nz-form-item>
                                            <nz-form-label #label nzSpan="24" nzFor="districtId">Quận
                                                huyện</nz-form-label>
                                            <nz-form-control nzSpan="24" nzErrorTip="Nhập quận huyện">
                                                <asc-autocomplete label="Quận huyện" [ascModel]="DistrictControl"
                                                    (ascModelChange)="changeDistrict($event)"
                                                    placeholder="Chọn quận huyện..." [getListAC]="getDistrictACFn">
                                                </asc-autocomplete>
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>
                                    <div nz-col nzSm="24" nzMd="8">
                                        <nz-form-item>
                                            <nz-form-label #label nzSpan="24" nzFor="wardId">Phường xã</nz-form-label>
                                            <nz-form-control nzSpan="24" nzErrorTip="Nhập phường xã">
                                                <asc-autocomplete label="Phường xã" [ascModel]="WardControl"
                                                    (ascModelChange)="changeWard($event)"
                                                    placeholder="Chọn phường xã..." [getListAC]="getWardACFn">
                                                </asc-autocomplete>
                                            </nz-form-control>
                                        </nz-form-item>
                                    </div>
                                </div>
                            </nz-tab>
                            <!-- <nz-tab [nzTitle]="'BỒI DƯỠNG VỀ GIÁO DỤC NGƯỜI KHUYẾT TẬT'">
                <div nz-row [nzGutter]="[24,24]">
                  <div nz-col [nzSpan]="24">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'field'" [nzSpan]="24">
                        <b>Đào tạo/bồi dưỡng về giáo dục người khuyết tật</b>
                      </nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <nz-radio-group formControlName="staffUnfostered" class="w-full">
                          <div nz-row [nzGutter]="[24,12]">
                            <div nz-col [nzSpan]="24">
                              <nz-form-label [nzFor]="'field'" [nzSpan]="24"> <label nz-radio
                                  [nzValue]="false">Chưa</label> </nz-form-label>
                            </div>
                            <div nz-col [nzSpan]="24" class="flex">
                              <nz-form-label [nzFor]="'field'"> <label nz-radio [nzValue]="true">Có</label>
                              </nz-form-label>
                              <div nz-row [nzGutter]="[24,24]" class="w-full">
                                <div nz-col [nzSpan]="6" *ngFor="let diploma of listDiploma; let i = index">
                                  <nz-form-item>
                                    <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                      <label nz-checkbox [nzTooltipTitle]="diploma.name" nz-tooltip nz-checkbox
                                        [ngModel]="diploma.checked" (ngModelChange)="diplomaChange($event, i)"
                                        [ngModelOptions]="{standalone :true}"
                                        [nzDisabled]="!validateForm.controls.staffUnfostered.value">
                                        {{ diploma.name }}
                                      </label>
                                    </nz-form-label>
                                  </nz-form-item>
                                </div>
                              </div>
                            </div>
                          </div>
                        </nz-radio-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>
              </nz-tab> -->
                        </nz-tabset>
                    </div>
                </div>
                <div *nzModalFooter>
                    <popup-btn-footer [isDisableUpdate]="false" [isUpdateAndAdd]="true" [isUpdateAndClose]="true"
                        (updateAndClose)="Update(true)" (updateAndAdd)="Update(false)"
                        (close)="close($event)"></popup-btn-footer>
                </div>
            </nz-card>
        </nz-tab>
        <nz-tab [nzTitle]="'B. NỘI DUNG KHẢO SÁT'">
            <div nz-row nzGutter="24">
                <!-- 1.Mức độ kỹ năng -->
                <div nz-col [nzSpan]="24">
                    <nz-form-item>
                        <nz-form-label [nzFor]="'field'"> <b>1. Tự đánh giá về kỹ năng giáo dục người khuyết tật</b>
                        </nz-form-label>
                    </nz-form-item>
                </div>
                <div nz-col [nzSpan]="8">
                    <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center">
                            <b>Các hoạt động dạy học và hỗ trợ người khuyết tật</b>
                        </nz-form-label>
                    </nz-form-item>
                </div>
                <div nz-col [nzSpan]="8">
                    <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center"> <b>Tham gia</b> </nz-form-label>
                    </nz-form-item>
                </div>
                <div nz-col [nzSpan]="8">
                    <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center"> <b>Mức độ kỹ năng</b> </nz-form-label>
                    </nz-form-item>
                </div>
                <ng-container *ngFor="let teachingAndSupport of listTeachingAndSupport; let i = index">
                    <div nz-col [nzSpan]="8">
                        <nz-form-item>
                            <nz-form-label class="text-center">
                                <span nz-tooltip [nzTooltipTitle]="teachingAndSupport.name"> {{ teachingAndSupport.name
                                    }} </span>
                            </nz-form-label>
                        </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="8">
                        <nz-form-item>
                            <nz-form-label [nzFor]="'field'" class="text-center" nzNoColon="true">
                                <nz-radio-group [ngModel]="teachingAndSupport.hasJoined"
                                    (ngModelChange)="hasJoinedTASChange($event, i)"
                                    [ngModelOptions]="{standalone :true}">
                                    <label nz-radio [nzValue]="false">Chưa</label>
                                    <label nz-radio [nzValue]="true">Có</label>
                                </nz-radio-group>
                            </nz-form-label>
                        </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="8">
                        <nz-form-item>
                            <nz-form-label [nzFor]="'field'" class="text-center" nzNoColon="true">
                                <nz-radio-group [(ngModel)]="teachingAndSupport.skillLevelId"
                                    [ngModelOptions]="{standalone :true}" [nzDisabled]="!teachingAndSupport.hasJoined">
                                    <label nz-radio *ngFor="let skillLevel of listSkillLevel" [nzValue]="skillLevel.id">
                                        {{ skillLevel.name }}</label>
                                </nz-radio-group>
                            </nz-form-label>
                        </nz-form-item>
                    </div>
                </ng-container>
                <!-- 2.kết quả áp dụng -->
                <div nz-col [nzSpan]="24">
                    <nz-form-item>
                        <nz-form-label [nzFor]="'field'">
                            <b>2. Kết quả áp dụng các nội dung đã được đào tạo, bồi dưỡng về giáo dục người khuyết
                                tật</b>
                        </nz-form-label>
                    </nz-form-item>
                </div>
                <div nz-col [nzSpan]="6">
                    <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center"> <b>Nội dung về giáo dục người khuyết
                                tật</b>
                        </nz-form-label>
                    </nz-form-item>
                </div>
                <div nz-col [nzSpan]="6">
                    <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center"> <b>Tham gia</b> </nz-form-label>
                    </nz-form-item>
                </div>
                <div nz-col [nzSpan]="6">
                    <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center"> <b>Áp dụng</b> </nz-form-label>
                    </nz-form-item>
                </div>
                <div nz-col [nzSpan]="6">
                    <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center"> <b>Kết quả áp dụng</b> </nz-form-label>
                    </nz-form-item>
                </div>
                <ng-container *ngFor="let trainingAndRetraining of listTrainingAndRetraining; let i = index">
                    <div nz-col [nzSpan]="6">
                        <nz-form-item>
                            <nz-form-label class="text-center">
                                <span nz-tooltip [nzTooltipTitle]="trainingAndRetraining.name"> {{
                                    trainingAndRetraining.name }} </span>
                            </nz-form-label>
                        </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="6">
                        <nz-form-item>
                            <nz-form-label [nzFor]="'field'" class="text-center" nzNoColon="true">
                                <nz-radio-group [ngModel]="trainingAndRetraining.hasJoined"
                                    (ngModelChange)="hasJoinedTATChange($event, i)"
                                    [ngModelOptions]="{standalone :true}">
                                    <label nz-radio [nzValue]="false">Chưa tham gia</label>
                                    <label nz-radio [nzValue]="true">Đã tham gia</label>
                                </nz-radio-group>
                            </nz-form-label>
                        </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="6">
                        <nz-form-item>
                            <nz-form-label [nzFor]="'field'" class="text-center" nzNoColon="true">
                                <nz-radio-group [ngModel]="trainingAndRetraining.applied"
                                    (ngModelChange)="appliedTATChange($event, i)" [ngModelOptions]="{standalone :true}"
                                    [nzDisabled]="!trainingAndRetraining.hasJoined">
                                    <label nz-radio [nzValue]="false">Chưa áp dụng</label>
                                    <label nz-radio [nzValue]="true">Đã áp dụng</label>
                                </nz-radio-group>
                            </nz-form-label>
                        </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="6">
                        <nz-form-item>
                            <nz-form-label [nzFor]="'field'" class="text-center" nzNoColon="true">
                                <nz-radio-group [(ngModel)]="trainingAndRetraining.resultsOfTrainingId"
                                    [ngModelOptions]="{standalone :true}" [nzDisabled]="!trainingAndRetraining.applied">
                                    <label nz-radio *ngFor="let resultsOfTraining of listresultsOfTraining"
                                        [nzValue]="resultsOfTraining.id">{{ resultsOfTraining.name }}</label>
                                </nz-radio-group>
                            </nz-form-label>
                        </nz-form-item>
                    </div>
                </ng-container>
                <!-- 3.Chế độ -->
                <div nz-col [nzSpan]="24">
                    <nz-form-item>
                        <nz-form-label [nzFor]="'field'"> <b>3. Các chế độ khi tham gia giáo dục người khuyết tật</b>
                        </nz-form-label>
                    </nz-form-item>
                </div>
                <div nz-col [nzSpan]="12">
                    <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center"> <b>Chế độ</b> </nz-form-label>
                    </nz-form-item>
                </div>
                <div nz-col [nzSpan]="12">
                    <nz-form-item>
                        <nz-form-label [nzFor]="'field'" class="text-center"> <b>Việc thực hiện</b> </nz-form-label>
                    </nz-form-item>
                </div>
                <ng-container *ngFor="let participation of listParticipation; let i = index">
                    <div nz-col [nzSpan]="12">
                        <nz-form-item>
                            <nz-form-label class="text-center">
                                <span nz-tooltip [nzTooltipTitle]="participation.name"> {{ participation.name }} </span>
                            </nz-form-label>
                        </nz-form-item>
                    </div>
                    <div nz-col [nzSpan]="12">
                        <nz-form-item>
                            <nz-form-label [nzFor]="'field'" class="text-center" nzNoColon="true">
                                <nz-radio-group [(ngModel)]="participation.made" [ngModelOptions]="{standalone :true}">
                                    <label nz-radio [nzValue]="true">Có</label>
                                    <label nz-radio [nzValue]="false">Không</label>
                                </nz-radio-group>
                            </nz-form-label>
                        </nz-form-item>
                    </div>
                </ng-container>
                <!-- 4.Ý kiến về sự phối hợp -->
                <div nz-col [nzSpan]="24">
                    <nz-form-item>
                        <nz-form-label [nzFor]="'field'" [nzSpan]="24">
                            <b>4. Ý kiến về sự phối hợp của lực lượng trong quá trình GD người khuyết tật (gia đình -
                                nhà trường -
                                cộng đồng)</b>
                        </nz-form-label>
                        <nz-form-control [nzSpan]="24">
                            <nz-radio-group formControlName="isCoordinationAsfac" class="w-full">
                                <div nz-row [nzGutter]="[0,0]">
                                    <div nz-col [nzSpan]="24">
                                        <nz-form-label [nzFor]="'field'" [nzSpan]="24"> <label nz-radio
                                                [nzValue]="false">Chưa</label>
                                        </nz-form-label>
                                    </div>
                                    <div nz-col [nzSpan]="24" class="flex">
                                        <nz-form-label [nzFor]="'field'"> <label nz-radio [nzValue]="true">Có</label>
                                        </nz-form-label>
                                        <div nz-row [nzGutter]="[0,0]" class="w-full">
                                            <div nz-col [nzSpan]="24" class="flex items-center">
                                                <nz-form-item>
                                                    <nz-radio-group formControlName="coordinationAsfacId"
                                                        [nzDisabled]="!validateForm.controls.isCoordinationAsfac.value">
                                                        <label *ngFor="let coordination of listCoordination" nz-radio
                                                            [nzValue]="coordination.id">
                                                            {{ coordination.name }}</label>
                                                    </nz-radio-group>
                                                </nz-form-item>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </nz-radio-group>
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>
        </nz-tab>
    </nz-tabset>
</form>
